import { render, staticRenderFns } from "./Founders.vue?vue&type=template&id=06d35fd3&"
import script from "./Founders.vue?vue&type=script&lang=js&"
export * from "./Founders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports